<template>
  <div id="orderListCenter">
    <div class="title">
      <p class="name">订单中心<span class="back" @click="back()" v-if="isApp!==2">返回<i class="backIcon">></i></span></p>
    </div>
    <div class="MainBody">
      <div class="tab">
        <ul>
          <li :class="[activeIndex === index ? 'active': '']" v-for="(item,index) in tabList" :key="item.id"
            @click="switchTab(item.key,index)">{{item.name}}</li>
        </ul>
      </div>
      <div class="listBox">
        <div v-if="mallDataList.length === 0">
          <div class="none">
            暂无数据
          </div>
        </div>
        <div class="item" @click="toDetail(item.id)" v-for="(item,index) in mallDataList" :key='item.id'
          v-show="item.status !== '交易关闭'">
          <div class="topLine">
            <div class="date">{{item.create_time}}
              <span class="StatuTag">{{item.status}}</span>
            </div>
          </div>
          <div class="detailPart">
            <div class="detailItem" v-for="(ite,inde) in item.tails.detailList" :key="ite.id">
              <!-- @click.stop.prevent="ckeckItem(ite.goods_id)"> -->
              <img :src="ite.coverimg" alt="" class="itemImg">
              <div class="itemDetail">
                <div class="leftPart">
                  <p class="itemName">{{ite.product_name}}</p>
                  <p class="specs">{{ite.spec_detail}}</p>
                </div>
                <div class="rightPart">
                  <p class="price">￥{{ite.unit_prices}}</p>
                  <p class="numb">X{{ite.number}}</p>
                </div>
              </div>
            </div>
            <div class="totalText">
              共{{item.total}}件商品 快递费：{{getFeeFun(item)}} 合计：<span>
                <font>￥</font>{{item.amounts}}
              </span>
            </div>
          </div>
          <div class="buttonPart" v-if="item.status !== '交易关闭'">
            <div v-if="item.pay_state == '未付款' && item.channel != 'remittance'">
              <span class="btn" v-if="item.delivery_method==2" @click.stop.prevent="changeAddr(item)">修改地址</span>
              <span class="btn" v-if="item.delivery_method==1" @click.stop.prevent="changeAddrzx(item)">更换门店</span>
              <span class="btn" @click.stop.prevent="del(item.id)">删除订单</span>
              <!-- <span class="btn active" @click.stop.prevent="applyClick(item.id, item.amounts)">立即付款</span> -->
              <span class="btn active" @click.stop.prevent="submit(item.id, item.amounts)">立即付款</span>
            </div>
            <div v-if="item.pay_state == '已付款' && item.logistics_status === 1">
              <span class="btn" @click.stop.prevent="al_goods(item.id)">提醒发货</span>
              <!-- <span class="btn" @click.stop.prevent="del(item.id)">删除订单</span> -->
              <span v-if="item.invoice_state==='未申请'" class="btn" @click.stop.prevent="reciveBill(item.id)">申请发票</span>
              <span v-else-if="item.invoice_state==='已申请'" class="btn btn_no" @click.stop.prevent="">已申请</span>
              <span v-else-if="item.invoice_state==='已开具'" class="btn" @click.stop.prevent="goToInvoice(item.id)">查看发票</span>
              <!-- <span v-else-if="item.invoice_state === '已申请'" class="btn grey">已申请</span>
              <span v-else-if="item.invoice_state === '已开具'" class="btn grey">已开票</span> -->

              <span v-if="docData[index].status === 0" class="btn"
                @click.stop.prevent="downLoadHeTong(index, item.id)">下载合同</span>
              <span v-else-if="docData[index].status === 1" class="btn"
                @click.stop.prevent="checkHeTong(index)">查看合同</span>
            </div>
            <div v-if="item.pay_state == '已付款' && item.logistics_status === 2">
              <!-- <span class="btn" @click.stop.prevent="goinfo(item.id)">查看物流</span> -->
              <span v-if="item.invoice_state==='未申请'" class="btn" @click.stop.prevent="reciveBill(item.id)">申请发票</span>
              <span v-else-if="item.invoice_state==='已申请'" class="btn btn_no" @click.stop.prevent="">已申请</span>
              <span v-else-if="item.invoice_state==='已开具'" class="btn" @click.stop.prevent="goToInvoice(item.id)">查看发票</span>
              <span v-if="!(item.delivery_method&&item.delivery_method==1)" class="btn active" @click.stop.prevent="confirmshop(item.id)">确认收货</span>
              <span v-if="docData[index].status === 0" class="btn"
                @click.stop.prevent="downLoadHeTong(index, item.id)">下载合同</span>
              <span v-else-if="docData[index].status === 1" class="btn"
                @click.stop.prevent="checkHeTong(index)">查看合同</span>
            </div>
            <div v-if="item.pay_state == '已付款' && item.logistics_status === 3">
              <span v-if="item.invoice_state==='未申请'" class="btn" @click.stop.prevent="reciveBill(item.id)">申请发票</span>
              <span v-else-if="item.invoice_state==='已申请'" class="btn btn_no" @click.stop.prevent="">已申请</span>
              <span v-else-if="item.invoice_state==='已开具'" class="btn" @click.stop.prevent="goToInvoice(item.id)">查看发票</span>
              <span v-if="docData[index].status === 0" class="btn"
                @click.stop.prevent="downLoadHeTong(index, item.id)">下载合同</span>
              <span v-else-if="docData[index].status === 1" class="btn"
                @click.stop.prevent="checkHeTong(index)">查看合同</span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <mt-popup v-model="show" :closeOnClickModal="0" position="bottom" class="pay-popup">
      <div class="header" @click="cancelClick">
        <div class="close"></div>
        <div class="tip">{{title}}</div>
      </div>
      <div class="pay-money pay-money4">
        <div class="money">
          ￥{{totalAmount}}
        </div>
      </div>
      <div class="pay-type">
        <div v-if="!iswx">
          <div class="pay-box" v-for="(value, index) in items" :key="value.id"
            @click="selPayTypeClick(1,value,value.id)">
            <img class="icon" :src="value.image" />
            <div>{{value.title}}</div>
            <img class="select" :id="forId(index)" :src="value.isSel?msgImg_s:msgImg_n" />
          </div>
        </div>
        <div v-if="iswx">
          <div class="pay-box" v-for="(value, index) in items2" :key="value.id"
            @click="selPayTypeClick(2,value,value.id)">
            <img class="icon" :src="value.image" />
            <div>{{value.title}}</div>
            <img class="select" :id="forId(index)" :src="value.isSel?msgImg_s:msgImg_n" />
          </div>
        </div>
      </div>
      <div class="bottom" :style="{marginBottom: tabHeight+'px'}">
        <div class="apply" @click="surePayClick" :style="{backgroundColor:activeStyle}">确认支付</div>
      </div>
      <!-- H5支付form表单 -->
      <div v-html="htmlForm"></div>
    </mt-popup>
    <!-- <payView type="5" :money="orderamount" :orderId="orderid" :show="payViewVisible" @payValue="payValue"></payView> -->
    <!--  支付成功弹窗  -->
    <!-- <SuccessView :show="showSuccessView" type="2" @successViewClick="successViewClick"></SuccessView> -->
    <div class="mask" v-if="masker || maskerSure || changeAddress"></div>
    <div class="makeSure" v-if="masker">
      <!-- <div class="cssPopTitle">
        <p>提示</p>
      </div> -->
      <div class="cssPopBody">
        <!-- <p class="cssWranningtext"><span class="cssWranning">!</span>此操作将删除该项目，是否继续？</p> -->
        <p class="cssWranningtext">确认删除订单？</p>
        <div class="cssBottombutton">
          <button @click="hideDelPop()" class="cssButtonCommon white">再想想</button>
          <button @click="delFun(orderid)" class="cssButtonCommon">确定删除</button>
        </div>
      </div>
    </div>
    <div class="makeSure" v-if="maskerSure">
      <!-- <div class="cssPopTitle">
        <p>提示</p>
      </div> -->
      <div class="cssPopBody sure">
        <!-- <p class="cssWranningtext"><span class="cssWranning">!</span>请确认是否已收到货物</p> -->
        <p class="cssWranningtext bold">确认收到货了？</p>
        <p class="cssWranningtext sub">为保障您的权益，请收到货确认无误后，再确认收货哦！</p>
        <div class="cssBottombutton">
          <button @click="hideSurePop()" class="cssButtonCommon white">取消</button>
          <button @click="Sure(orderid)" class="cssButtonCommon">确认收货</button>
        </div>
      </div>
    </div>
    <div class="makeSure change" v-if="changeAddress">
      <div class="cssPopTitle">
        <p>修改地址信息</p>
      </div>
      <div class="cssPopBody">
        <form class="form" action="">
          <div class="inner">
            <span>收货人：</span><input type="text" maxlength="20" :placeholder="address.receiver" v-model="form.receiver">
          </div>
          <div class="inner">
            <span>收货人手机号：</span><input type="text" maxlength="11" :placeholder="address.user_phone"
              v-model="form.user_phone" oninput="value=value.replace(/[^\d]/g,'')">
          </div>
          <div class="inner">
            <span>地址信息：</span><input type="text" maxlength="30" disabled :placeholder="address.province_city_area"
              v-model="form.province_city_area" @click="changeAddre">
          </div>
          <div class="inner">
            <span>详细地址：</span><textarea type="text" maxlength="50" :placeholder="address.detail_address"
              v-model="form.detail_address"></textarea>
          </div>
        </form>
        <div class="submit">
          <span class="submitBtn cancel" @click="cancle()">取消</span>
          <span class="submitBtn" @click="sub(form)">修改</span>
        </div>
      </div>
    </div>
    <AreaView :show="showAddress" @selectedArea="selectedArea"></AreaView>
    <van-action-sheet v-model="changeShopShow"  title="更换门店" @close="closeSheet" :round=false>
      <changeShop @changeShopDetail="changeShopDetail" :clickItemDetail="clickItemDetail"></changeShop>
    </van-action-sheet>
  </div>
</template>

<script>
import AreaView from '../../../components/area-view'
import pdf from 'vue-pdf'
import { Toast } from 'mint-ui'
import wxshare from '../../../wx/weixin'
import { mapState } from 'vuex'
import changeShop from '../../../components/changeShop.vue'
export default {
  inject: ['reload'],
  computed: {
    ...mapState({
      orderId: 'MallOrderId'
    }),
    isActive () {
      if (this.payIndex > 0) {
        return true
      } else {
        return false
      }
    }
  },
  components: {
    AreaView,
    pdf,
    changeShop
  },
  watch: {

    isActive: function (val) {
      if (val === true) {
        this.activeStyle = '#C41335'
      } else {
        this.activeStyle = '#FECDCD'
      }
    }
  },
  data () {
    return {
      isApp: 0,
      masker: false,
      activeIndex: 0,
      cdn: 'http://cdn.zxzx119.com/',
      show: false,
      total: 0,
      totalAmount: 0,
      title: '支付金额',
      items: [
        { id: '1', title: '支付宝支付', image: require('../../../assets/icon_pay_alipay.png'), isSel: 0 },
        { id: '2', title: '微信支付', image: require('../../../assets/icon_pay_wx.png'), isSel: 0 },
        { id: '3', title: '银行汇款', image: require('../../../assets/icon_pay_bank.png'), isSel: 0 }
      ],
      items2: [
        { id: '2', title: '微信支付', image: require('../../../assets/icon_pay_wx.png'), isSel: 0 },
        { id: '3', title: '银行汇款', image: require('../../../assets/icon_pay_bank.png'), isSel: 0 }
      ],
      payType: '',
      payIndex: 0,
      payInfo: {
        id: ''
      },
      msgImg_n: require('../../../assets/radio_n.png'),
      msgImg_s: require('../../../assets/radio_s.png'),
      iswx: false,
      payOrderId: '',
      tabHeight: 30,
      activeStyle: '#FECDCD',
      htmlForm: '',
      orderid: 0,
      orderamount: 0,
      showAddress: false,
      payViewVisible: false,
      showSuccessView: false,
      changeAddress: false,
      maskerSure: false,
      orderstatus: '',
      clickTime: 0,
      status: this.$route.query.status, // 0 待付款 1 待发货 2 待收货 3 已完成 4 全部  /company/zxOrder/myMallOrderList
      mallDataList: [
        {
          tails: {
            detailList: []
          }
        }
      ],

      docData: [],
      address: [
        {
          user_phone: ''
        }
      ],
      form: {
        area: '',
        city: '',
        detail_address: '',
        orderId: '',
        province: '',
        province_city_area: '',
        receiver: '',
        user_phone: ''
      },
      currentPage: 0,
      changeShopShow: false,
      tabList: [
        {
          id: 0,
          key: 4,
          name: '全部订单'
        },
        {
          id: 1,
          key: 0,
          name: '待付款'
        },
        {
          id: 2,
          key: 1,
          name: '待发货'
        },
        {
          id: 3,
          key: 2,
          name: '待收货'
        },
        {
          id: 4,
          key: 3,
          name: '已完成'
        }
      ],
      clickItemDetail: '' // 点击更换门店订单信息
    }
  },
  methods: {
    goToInvoice (id) {
      this.$router.push({
        path: '/invoiceDetail',
        query: {
          orderId: id
        }
      })
    },
    getFeeFun (item) {
      let fee = 0
      if (item.delivery_method) { // 兼顾老数据订单
        if (item.delivery_method == 1 || (item.tails.promotion_code && item.tails.promotion_code !== '')) { // 自提或者有优惠码
          fee = 0
        } else if (item.delivery_method == 2) {
          fee = item.fee
        }
      } else {
        fee = item.fee
      }
      return fee
    },
    ckeckItem (id) {
      this.$router.push({
        path: '/goodsdetail',
        query: {
          goodsId: id,
          bussinessId: 26116
        }
      })
    },
    androidTabHeight: function (value) {
      // 设置android 模态导航条
      if (this.utils.isIphone() === true) {
        if (this.utils.isIphoneX() === true) {
          this.tabHeight = 20
        } else {
          this.tabHeight = 0
        }
      } else {
        this.tabHeight = parseInt(this.tabHeight) + parseInt(value)
      }
      console.log('zhifutabHeight:', this.tabHeight)
    },
    submit (id, amount) {
      this.totalAmount = amount
      this.payOrderId = id
      this.show = true
    },
    forId (index) {
      return 'selectImg' + index
    },
    selPayTypeClick (index, value, id) {
      // this.getOrderId()
      this.payIndex = parseInt(id)
      switch (this.payIndex) {
        case 1:
          // this.payType = 'alipay_pc_direct'
          this.payType = 'alipay_wap'
          break
        case 2:
          if (this.utils.isWX()) {
            this.payType = 'wx_jsapi'
          } else {
            this.payType = 'wx_wap'
          }
          break
        case 3:
          this.payType = 'remittance'
          break
      }
      if (index === 1) {
        this.items.forEach((item, index) => {
          item.isSel = 0
        })
      } else {
        this.items2.forEach((item, index) => {
          item.isSel = 0
        })
      }
      value.isSel = 1
    },
    cancelClick () {
      this.show = false
    },
    surePayClick () {
      if (this.isActive) {
        if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1) {
          // 消防云 中消商城  支付宝 微信支付  下单 支付
          // app 内嵌网页掉支付
          var enterType = localStorage.getItem('enterType')
          if (enterType === undefined || enterType === null) {
            enterType = 0
          } else {
            enterType = parseInt(enterType)
          }
          console.log('listenterType:', enterType)
          if (enterType === 1) { // app 内嵌网页掉支付
            if (this.payIndex === 3) { // 线下 审核汇款
              console.log('===================线下汇款')
              this.$router.push({ path: '/remittance', query: { orderID: this.payOrderId } })
            } else {
              if (this.utils.isIphone()) { // ios 支付
                // Toast('iOS -- app内嵌h5支付')
                window.webkit.messageHandlers.startPay.postMessage({
                  'payType': this.payType,
                  'orderId': this.payOrderId
                })
              } else {
                // Toast('Android -- app内嵌h5支付')
                window.zxzx.startPay(this.payType, this.payOrderId)
              }
              // 查询支付状态
              this.payState()
            }
            return
          }
          return
        }

        if (this.utils.isWX()) {
          if (this.payType === 'wx_jsapi') {
            if (localStorage.getItem('openId') !== null) {// 已经授权过有了openid
                  this.toPay(this.payOrderId, localStorage.getItem('openId'))
                  return false;
              } else {//去授权
                  let redirectURI = encodeURIComponent(window.location.href)
                  window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+this.appIdMall +
                  '&redirect_uri=' + redirectURI +
                  '&response_type=code&scope=snsapi_base&state=WXPaySTATE&connect_redirect=1#wechat_redirect'
              }
          }
        }


        
        if (this.payIndex === 3) {
          this.$router.push({ path: '/remittance', query: { orderID: this.payOrderId } })
        } else {
          console.log('list newPay')

          this.utils.post(this.companyUrl + '/newPay/' + this.payType + '/' + this.payOrderId, null, res => {
            // this.utils.post(this.companyUrl + '/newPay/' + this.payType + '/' + result, null, res => {
            let payUrl = res.data.payUrl
            if (payUrl.indexOf('http') === 0) { // 微信
              // this.PostcheckState(this.orderId)
              //   // console.log(payUrl)
              //   // return
              window.location.href = payUrl
            } else { // 支付宝
              // console.log(payUrl)
              // return
              this.htmlForm = payUrl
              setTimeout(function () {
                document.forms[0].submit()
              }, 500)
            }
          })
        }
      }
    },
    toDecimal2 (x) {
      var f = parseFloat(x)
      if (isNaN(f)) {
        return false
      }
      var E = Math.round(x * 100) / 100
      var s = E.toString()
      var rs = s.indexOf('.')
      if (rs < 0) {
        rs = s.length
        s += '.'
      }
      while (s.length <= rs + 2) {
        s += '0'
      }
      return s
    },

    FenToYuan (data) {
      let num = data
      num = data * 0.01
      num += ''
      let reg = num.indexOf('.') > -1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g
      num = num.replace(reg, '$1')
      num = this.toDecimal2(num)
      return num
    },
    changeAddr (item) {
      this.changeAddress = true
      this.address = item.tails.detailList[0]
      this.address.user_phone = item.user_phone
      this.orderid = item.id
      this.form = this.address
    },
    changeAddrzx (item) {
      console.log('点击更换门店:', item)
      this.changeShopShow = true
      this.orderid = item.id
      this.clickItemDetail = item
    },
    closeSheet () {
      this.changeShopShow = false
    },
    changeAddre () {
      this.showAddress = true
    },
    changeShopDetail (item) {
      this.utils.post(this.companyUrl + '/zxOrder/changeCustomStore', {
        orderId: this.orderid,
        customShopId: JSON.parse(item).id
      }, res => {
        console.log('zxOrder/changeCustomStore:,', res)
        this.$message.success(res.message)
        this.changeShopShow = false
        this.getDetail()
      })
    },
    selectedArea: function (province, city, area, code) {
      this.showAddress = false
      if (province.length <= 0) {
        return
      }
      this.form.province = province
      this.form.city = city
      this.form.area = area
      this.form.province_city_area = province + ' ' + city + ' ' + area
    },
    sub (form) {
      if (form.receiver === '') {
        Toast('请输入收货人姓名')
      } else if (form.user_phone === '') {
        Toast('请输入收货人手机号码')
      } else if (!this.utils.isPhone(form.user_phone)) {
        Toast('请输入正确的手机号')
        form.user_phone = ''
      } else if (form.province_city_area === '') {
        Toast('请选择收货地址')
      } else if (form.detail_address === '') {
        Toast('请输入详细收货地址')
      } else {
        form.orderId = this.orderid
        let obj = {
          area: form.area,
          city: form.city,
          detail_address: form.detail_address === '' ? this.address.detail_address : form.detail_address,
          orderId: form.orderId,
          province: form.province,
          province_city_area: form.province_city_area === '' ? this.address.province_city_area : form.province_city_area,
          receiver: form.receiver === '' ? this.address.receiver : form.receiver,
          user_phone: form.user_phone === '' ? this.address.user_phone : form.user_phone
        }
        this.utils.post(this.companyUrl + '/zxOrder/changeAddress', obj, res => {
          this.$message.success(res.message)
          this.changeAddress = false
          this.getDetail()
        })
      }
    },
    hideDelPop () {
      this.masker = false
    },
    cancle () {
      this.changeAddress = false
    },
    delFun (id) {
      this.utils.POST(this.companyUrl + '/zxOrder/deleteOrder',
        {
          order_id: id
        },
        resj => {
          this.masker = false
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getDetail()
        }
      )
    },
    del (id) {
      this.orderid = id
      this.masker = true
    },
    applyClick (id, amount) {
      this.orderid = id
      this.$store.commit('storeOrderId', id)
      this.orderamount = amount
      this.payViewVisible = true
    },
    payValue: function (state) {
      if (state === 1) {
        this.showSuccessView = true
      }
      this.payViewVisible = false
    },
    successViewClick: function () {
      this.showSuccessView = false
      this.getDetail()
    },
    reciveBill (id) {
      this.$router.push({
        path: '/billCenter',
        query: {
          billCenterType: 1,
          orderNo: id
        }
      })
    },
    al_goods (id) {
      this.utils.POST(this.companyUrl + '/zxOrder/remindDelivery',
        {
          order_id: id
        },
        resj => {
          this.$message.success(resj.message)
        }
      )
    },
    goinfo (id) {
      this.$router.push({
        path: '/orderListDetail',
        query: {
          orderId: id
        }
      })
    },
    confirmshop (id) {
      this.orderid = id
      this.maskerSure = true
    },
    Sure (id) {
      this.utils.POST(this.companyUrl + '/zxOrder/confirmReceipt',
        {
          order_id: id
        },
        resj => {
          this.$message.success(resj.message)
          this.maskerSure = false
          this.getDetail()
        }
      )
    },
    hideSurePop () {
      this.maskerSure = false
    },
    switchTab (key, index) {
      this.activeIndex = index
      this.status = key
      let path = this.$router.history.current.path
      let newQuery = {status: key, tag: index}
      this.$router.replace({ path, query: newQuery })
      this.getDetail()
    },
    logoutClick () {

    },
    back () {
      localStorage.setItem('tab', 2)
      this.$router.replace({
        path: '/homePage/personHomePage'
      })
    },
    checkHeTong (index) {
      console.log(index)
      window.open(this.cdn + this.docData[index].doc_url)
    },
    downLoadHeTong (index, id) {
      let src = this.companyUrl + '/zxOrder/downSalesContract?orderId=' + id
      let a = document.createElement('a')
      a.href = src
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    getDetail () {
      let obj = {
        status: this.status,
        key: '',
        page: this.currentPage + 1,
        rows: 999
      }
      this.utils.get(this.companyUrl + '/zxOrder/myMallOrderList', obj, res => {
        if (res.code === 0) {
          this.docData = []
          this.mallDataList = []
          // let dealArry = []
          // console.log(res.data)
          let DealArry = res.data.rows
          DealArry.forEach((item, index) => {
            item.create_time = this.utils.dealTime(item.create_time)
            let total = 0
            item.tails.detailList.forEach((ite, ind) => {
              let str = ''
              let spec = JSON.parse(ite.spec_detail)
              total += ite.number
              for (let key in spec) {
                str = str + key + ':' + spec[key] + ' '
              }
              ite.unit_prices = this.FenToYuan(ite.unit_price)
              ite.spec_detail = str
              ite.coverimg = ite.product_cover.split(',')[0]
            })
            item['status'] = this.dealStatus(item)
            item['total'] = total
            if ('mallOrderDoc' in item.tails) {
              this.docData.push(item.tails.mallOrderDoc)
            } else {
              let obj = {
                status: 2
              }
              this.docData.push(obj)
            }
            item['fee'] = this.FenToYuan(item.freight)
            item.amounts = this.FenToYuan(parseInt(item.amount))
          })
          this.mallDataList = DealArry
        }
      })
    },
    dealStatus (item) {
      let str = ''
      if (item.order_state === '失效') {
        str = '交易关闭'
      } else if (item.pay_state === '已退款') {
        str = '已退款'
      } else if (item.pay_state === '未付款' && item.channel !== 'remittance') {
        str = '待付款'
      } else if (item.pay_state === '未付款' && item.channel === 'remittance') {
        str = '汇款审核中'
      } else if (item.pay_state === '已付款' && item.logistics_status === 1) {
        str = '待发货'
      } else if (item.pay_state === '已付款' && item.logistics_status === 2) {
        if (item.delivery_method && item.delivery_method == 1) {
          str = '待提货'
        } else {
          str = '待收货'
        }
      } else if (item.pay_state === '已付款' && item.logistics_status === 3) {
        str = '已完成'
      }
      return str
    },
    toDetail (id) {
      this.$store.commit('clearOrderId', '')
      this.$router.push({
        path: '/orderListDetail',
        query: {
          orderId: id
        }
      })
    },
    getopenId (code) {
      this.utils.post(this.companyUrl + '/newPay/getOpenId?code=' + code, null, res => {
        if (res.code === 0) {
          localStorage.setItem('openId', res.data)
          // this.toPay(this.orderId, res.data)
        }
      })
    },
    onBridgeReady (data) {
      let param = data.payParams
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          'appId': param.appId, // 公众号名称，由商户传入
          'timeStamp': param.timeStamp, // 时间戳，自1970年以来的秒数
          'nonceStr': param.nonceStr, // 随机串
          'package': param.package,
          'signType': param.signType, // 微信签名方式：
          'paySign': param.paySign // 微信签名
        },
        res => {
          // if (res.err_msg === 'get_brand_wcpay_request:ok') {
            this.$store.commit('clearOrderId', '')
            // this.switchTab(4, 0)
              window.location.reload(true);
          // }
        })
    },
    launchWXPay (data) { // 微信浏览器发起微信支付 wx_jsapi
      if (typeof window.WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(data), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(data))
          document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(data))
        }
      } else {
        this.onBridgeReady(data)
      }
    },
    toPay (orderid, openId) {
      this.utils.post(this.companyUrl + '/newPay/wx_jsapi/' + orderid + '?openId=' + openId, null, res => {
        console.log(res)
        if (res.code === 0) {
          this.launchWXPay(res.data)
        }
      })
    },
    paySuccess (state) {
      if (state === '0') {
        // 支付成功，跳转至订单列表
        this.$store.commit('clearOrderId', '')
        this.reload()
        // this.$router.push({
        //  path: '/orderListCenter',
        //  query: {
        //    status: 4,
        //    tag: 0
        // }
        // })
      }
    },
    WX () {
      let ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    this.getDetail()
    if (this.$route.query.isApp) {
      this.isApp = parseInt(this.$route.query.isApp)
      localStorage.setItem('isApp', parseInt(this.$route.query.isApp))
      if (this.isApp === 2) {
        this.utils.GET(this.companyUrl + '/ent/json',
          function (res) {
            localStorage.setItem('userinfo', JSON.stringify(res.data))
          })
      }
    } else if (parseInt(localStorage.getItem('isApp'))) {
      this.isApp = parseInt(localStorage.getItem('isApp'))
    }
  },
  mounted () {
    let _this = this
    console.log(_this.$router)
    window['paySuccess'] = (result) => {
      _this.paySuccess(result)
    }
    this.iswx = this.WX()
    this.getDetail()
    wxshare.wxShareHomePage('【中消在线】消防安全产品一站式采购平台', '品质保障，正品低价，支持线上交易', 'http://cdn.zxzx119.com/1294196519632633856')
    this.activeIndex = parseInt(this.$route.query.tag)
    if (this.utils.isWX()) {
      if (this.$route.query.code !== undefined && localStorage.getItem('openId') === null) { // 首次授权重定向
        this.getopenId(this.$route.query.code)
      }
    }
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 ||
      parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      window['androidTabHeight'] = (result) => {
        _this.androidTabHeight(result)
      }
      if (this.utils.isIphone() === true) {
        this.androidTabHeight('0')
      } else {
        this.androidTabHeight(window.zxzx.getNavigationBarHeight())
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#orderListCenter {
  background: #f6f3f7;
  min-height: 100vh;
}
.title {
  height: 50px;
  line-height: 50px;
  padding: 0 16.5px 0 14px;
  background: #ffffff;
  .name {
    font-size: 15px;
    color: #000000;
    font-weight: bold;
    .back {
      float: right;
      font-size: 13px;
      color: #999999;
      .backIcon {
        display: inline-block;
        vertical-align: top;
        margin-left: 5px;
        font-size: 13px;
        color: #999999;
        font-style: inherit;
      }
    }
  }
}
.MainBody {
  padding: 11px 15px 100px 15px;
  .tab {
    background: #ffffff;
    width: 100%;
    border-radius: 4px;
    margin-bottom: 9.5px;
    ul {
      display: flex;
      height: 40px;
      li {
        flex: 1;
        font-size: 13px;
        color: #808080;
        line-height: 40px;
        text-align: center;
      }
      .active {
        font-size: 13px;
        color: #c41335;
      }
    }
  }
  .listBox {
    width: 100%;
    display: inline-block;
    .none {
      position: relative;
      text-align: center;
      width: 100%;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      color: #cccccc;
    }
    // .none::before {
    //   position: absolute;
    //   content: "";
    //   height: 1px;
    //   width: 115px;
    //   background: #808080;
    //   top: 14px;
    //   left: 0;
    //   // width: ;
    // }
    // .none::after {
    //   position: absolute;
    //   content: "";
    //   height: 1px;
    //   width: 115px;
    //   top: 14px;
    //   right: 0;
    //   background: #808080;
    // }
    .item {
      width: 100%;
      background: #ffffff;
      border-radius: 4px;
      margin-bottom: 10px;
      .topLine {
        height: 40px;
        line-height: 40px;
        padding: 0 10px 0 10px;
        border-bottom: 1px solid #eeeeee;
        .date {
          display: inline-block;
          width: 100%;
          font-size: 12px;
          color: #808080;
          text-align: left;
          .StatuTag {
            float: right;
            font-size: 12px;
            color: #c41335;
          }
          .grey {
            color: #808080;
          }
        }
      }
      .detailPart {
        padding: 15px 10px 16px 10px;
        font-size: 0;
        border-bottom: 1px solid #eeeeee;
        .detailItem {
          width: 100%;
          height: 50px;
          margin-bottom: 16px;
          .itemImg {
            display: inline-block;
            width: 50px;
            height: 50px;
            border: 0.01rem solid #eeeeee;
            vertical-align: top;
            margin-right: 11px;
          }
          .itemDetail {
            width: calc(100% - 61px);
            // width: 100%;
            display: inline-block;
            .leftPart {
              display: inline-block;
              .itemName {
                width: 160px;
                font-size: 12px;
                line-height: 17px;
                color: #000000;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
              .specs {
                width: 160px;
                font-size: 12px;
                color: #bebebe;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
            .rightPart {
              float: right;
              text-align: right;
              .price {
                font-size: 13px;
                color: #000000;
              }
              .numb {
                font-size: 13px;
                color: #bebebe;
              }
            }
          }
        }
        .totalText {
          text-align: right;
          line-height: 16px;
          font-size: 12px;
          color: #808080;
          span {
            font-weight: bold;
            font-size: 16px;
            color: #000000;
            font {
              font-size: 12px;
              color: #000000;
            }
          }
        }
      }
      .buttonPart {
        width: 100%;
        line-height: 42px;
        text-align: right;
        font-size: 0;
        div {
          line-height: 0;
          padding: 10px 10px 10px 0;
          span {
            display: inline-block;
            margin-left: 10px;
            padding: 5px 8.5px 6px 9px;
            font-size: 12px;
            color: #808080;
            line-height: 12px;
            border: 1px solid #808080;
            border-radius: 3px;
          }
          .btn_no{
            background: #EEEEEE;
            border: 1px solid #DADADA;
          }
          .active {
            background: #c41335;
            border: 1px solid #c41335;
            color: #ffffff;
          }
          .grey {
            background: #eeeeee;
            border: 1px solid #eeeeee;
            color: #bebebe;
          }
        }
      }
    }
  }
}
.pay-popup {
  width: 100%;
  .header {
    position: relative;
    width: 100%;
    height: 45px;
    line-height: 45px;
    color: #000000;
    font-size: 17px;
    /*background-color: #C41335;*/
    border-bottom: solid #eeeeee 1px;
    box-sizing: border-box;
    .close {
      position: absolute;
      top: 15px;
      left: 15px;
      width: 15px;
      height: 15px;
      padding: 5px;
      background-image: url("../../../assets/icon-pay-close.png");
      background-size: cover;
      background-position: center center;
    }
    .tip {
      position: absolute;
      left: 0px;
      right: 0px;
      text-align: center;
    }
  }
  .pay-money {
    position: relative;
    .money {
      position: relative;
      height: 60px;
      padding-top: 30px;
      line-height: 30px;
      font-size: 25px;
      font-weight: bold;
      color: #c41335;
      text-align: center;
    }
  }
  .pay-type {
    position: relative;
    width: 100%;
    /*top: 30px;*/
    padding-top: 10px;
    height: 190px;
    /*height: 130px;*/
    /*background-color: yellow;*/
    .pay-box {
      position: relative;
      width: 100%;
      height: 60px;
      line-height: 60px;
      /*background-color: #4BAE4F;*/
      .icon {
        position: absolute;
        top: 20px;
        left: 15px;
        width: 20px;
        height: 20px;
      }
      div {
        position: absolute;
        top: 0px;
        left: 50px;
        width: calc(100% - 60px);
        height: 60px;
        line-height: 60px;
        border-bottom: solid #eeeeee 1px;
        box-sizing: border-box;
      }
      .select {
        position: absolute;
        top: 20px;
        right: 15px;
        width: 20px;
        height: 20px;
      }
    }
  }
  .bottom {
    position: relative;
    width: 100%;
    bottom: 0px;
    height: 65px;
    line-height: 65px;
    background-color: #ffffff;
    /*border-top: solid #EEEEEE 1px;*/
    /*box-sizing: border-box;*/
    .apply {
      position: absolute;
      top: 10px;
      left: 15px;
      height: 45px;
      line-height: 45px;
      width: calc(100% - 30px);
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      background-color: #c41335;
      border-radius: 4px;
    }
  }
}
.mask {
  position: fixed;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #000000;
  opacity: 0.4;
  z-index: 1000;
  top: 0;
  left: 0;
}
.makeSure {
  position: fixed;
  top: calc(50% - 120px);
  width: 305px;
  background: #ffffff;
  z-index: 1001;
  left: 0;
  right: 0;
  margin: 0 auto;
  .cssPopTitle {
    height: 45px;
    background: #c41335;
    p {
      text-align: left;
      font-size: 14px;
      color: #ffffff;
      height: 45px;
      line-height: 45px;
      padding-left: 15px;
    }
  }
  .cssPopBody {
    width: 100%;
    border-radius: 4px;
    background: #ffffff;
    display: inline-block;
    padding: 55px 34px 40px 34px;
    .cssWranningtext {
      text-align: center;
      // margin-left: 22.5px;
      font-size: 14px;
      color: #000000;
      margin-bottom: 44px;
      .cssWranning {
        display: inline-block;
        padding: 2px 8px 2px 8px;
        line-height: 16.5px;
        width: 19.5px;
        height: 19.5px;
        border-radius: 50%;
        background: #eea332;
        color: #ffffff;
        font-size: 14px;
        margin-right: 8px;
      }
    }

    .form {
      width: 100%;
      padding: 15px 0 0 30px;
      text-align: left;
      .inner {
        width: 100%;
        line-height: 35px;
        margin-bottom: 15px;
        span {
          display: inline-block;
          width: 90px;
          font-size: 12px;
          color: #000000;
          vertical-align: top;
        }
        input {
          color: #000000;
          font-size: 12px;
          width: 175px;
          text-indent: 5px;
          border: 0.01rem solid #dcdfe6;
          border-radius: 4px;
          line-height: 35px;
        }
        textarea {
          color: #000000;
          font-size: 12px;
          width: 175px;
          border: 0.01rem solid #dcdfe6;
          border-radius: 4px;
          line-height: 16px;
          height: 60px;
          padding: 5px;
          -webkit-appearance: none;
        }
        input::placeholder,
        textarea::placeholder {
          color: #000000;
          font-size: 12px;
        }
      }
    }
    .submit {
      text-align: center;
      line-height: 40px;
      .submitBtn {
        display: inline-block;
        font-size: 14px;
        color: #ffffff;
        background: #c41335;
        border-radius: 4px;
        line-height: 14px;
        padding: 8px 15px 9px 15px;
      }
    }
  }
  .sure {
    padding: 39px 34px 40px 34px;
    .bold {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 19px;
      line-height: 18px;
    }
    .sub {
      text-align: center;
      font-size: 14px;
      color: #000000;
      margin-bottom: 40px;
    }
  }
  .cssBottombutton {
    text-align: center;
    font-size: 0;
    .cssButtonCommon {
      background: #c41335;
      font-size: 14px;
      // line-height: 14px;
      color: #ffffff;
      display: inline-block;
      width: 112px;
      height: 45px;
      line-height: 45px;
      // padding: 16px 36px 16px 36px;
      border-radius: 4px;
      margin-left: 10px;
    }
    .white {
      margin-left: 0px;
      font-size: 14px;
      background: #ffffff;
      color: #c41335;
      border: 0.01rem solid #c41335;
    }
  }
}
.change {
  top: calc(50% - 240px);
  .cssPopBody {
    width: 100%;
    border-radius: 4px;
    background: #ffffff;
    display: inline-block;
    padding: 30px 15px 40px 15px;
    .form {
      padding: 0;
      .inner {
        width: 100%;
        line-height: 20px;
        margin-bottom: 15px;
        span {
          display: inline-block;
          width: 125px;
          font-size: 12px;
          color: #000000;
          vertical-align: top;
        }
        input,
        textarea {
          color: #000000;
          font-size: 12px;
          width: 150px;
          text-indent: 5px;
          border: 0.01rem solid #dcdfe6;
          border-radius: 4px;
          -webkit-appearance: none;
        }
        input::placeholder,
        textarea::placeholder {
          color: #bdbdbd;
          font-size: 12px;
        }
      }
    }
    .submit {
      .submitBtn {
        display: inline-block;
        width: 110px;
        font-size: 14px;
        color: #ffffff;
        height: 40px;
        line-height: 40px;
        padding: 0;
      }
      .cancel {
        color: #c41335;
        background: #ffffff;
        border: 0.01rem solid #c41335;
        margin-right: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/shopping/personCenter/orderListCenter.vue